// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZnAs","textarea":"styles_textarea__2y8Gz"};